import classnames from 'classnames';
import React from 'react';

import css from './defaultIconStyles.css';

export default function IconRoute({
    width = '16',
    height = '16',
    className,
    ...rest
}) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 16 16"
            className={classnames(css.main, css.colored, className)}
            {...rest}
        >
            <path
                fillRule="evenodd"
                d="M9.5,9 L6.5,9 C5.672,9 5,9.672 5,10.5 C5,11.328 5.672,12 6.5,12 L9.036,12 C9.278,10.305 10.738,9 12.5,9 C14.432,9 16,10.568 16,12.5 C16,14.432 14.432,16 12.5,16 C11.105,16 9.899,15.182 9.337,14 L6.5,14 C4.568,14 3,12.432 3,10.5 C3,8.568 4.568,7 6.5,7 L9.5,7 C10.328,7 11,6.328 11,5.5 C11,4.672 10.328,4 9.5,4 L6.964,4 C6.722,5.695 5.262,7 3.5,7 C1.568,7 0,5.432 0,3.5 C0,1.568 1.568,0 3.5,0 C4.895,0 6.101,0.818 6.663,2 L9.5,2 C11.432,2 13,3.568 13,5.5 C13,7.432 11.432,9 9.5,9 Z"
            />
        </svg>
    );
}
